import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import usePublic from '../../../utilities/usePublic';

const LoginLogoContainer = styled.div`
    text-align: center;

    img {
        max-width: 262px;
        max-height: 80px;
        margin: 0px;
        object-fit: contain;
    }
`;

const LoginLogo = () => {
    const company = useCompany(true);
    const defaultLogo = usePublic('logos/afcFullLogo.png');

    return (
        <LoginLogoContainer>
            <Link to="/">
                <img alt="logo" src={company?.logo?.url || defaultLogo} />
            </Link>
        </LoginLogoContainer>
    );
};

export default LoginLogo;
